import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=d97b5a12&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=js&"
export * from "./ImageModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=d97b5a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/cartaz-pratico/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b5a12",
  null
  
)

export default component.exports